import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormControl } from '@angular/forms';
import { KorisniciClient } from '@kodit/core/data-api';
import { SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';

export interface KorisnickaGrupaDropdownOption {
  value: string;
  label: string;
}

@Component({
  selector: 'kodit-korisnicka-grupa-dropdown',
  templateUrl: './korisnicka-grupa-dropdown.component.html',
  styleUrls: ['./korisnicka-grupa-dropdown.component.scss'],
})
export class KorisnickaGrupaDropdownComponent implements OnInit, OnDestroy {
  private _subs: Subscription = new Subscription();

  /** Props */
  formCtrl: FormControl = new FormControl();
  items: KorisnickaGrupaDropdownOption[] = [];
  korisnickeGrupe: KorisnickaGrupaDropdownOption[] = [];

  /** I/O */
  @Input() korisnickaGrupaIdCtrl: FormControl;
  @Input() formCtrlId: string;

  @Output() korisnickaGrupaChanged = new EventEmitter<KorisnickaGrupaDropdownOption>();


  constructor(private _client: KorisniciClient) {}

  ngOnInit(): void {
    this._load();
  }

  private _load() {
    this._subs.add(
      this._client.getKorisnickaGrupaDropdown().subscribe((res) => {
        res.data.korisnickaGrupaDropdownDtoList.forEach((g) => {
          this.items.push({
            value: g.id,
            label: g.naziv,
          });
        });
      })
    );

    this._subs.add(this.formCtrl.valueChanges.subscribe((res: string)  => {
      const selectedGrupa = this.items.find(x => x.value === res);
      this.korisnickaGrupaIdCtrl.patchValue(selectedGrupa.value);
      this.korisnickaGrupaChanged?.emit(selectedGrupa);
    }));
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
